// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file AirSpaceBoundaryVertexLine.proto (package AirSpaceBoundaryVertexLine, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { AirSpaceBoundaryVertex } from "./AirSpaceBoundaryVertex_pb";
import { file_AirSpaceBoundaryVertex } from "./AirSpaceBoundaryVertex_pb";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file AirSpaceBoundaryVertexLine.proto.
 */
export const file_AirSpaceBoundaryVertexLine: GenFile = /*@__PURE__*/
  fileDesc("CiBBaXJTcGFjZUJvdW5kYXJ5VmVydGV4TGluZS5wcm90bxIaQWlyU3BhY2VCb3VuZGFyeVZlcnRleExpbmUigQIKGkFpclNwYWNlQm91bmRhcnlWZXJ0ZXhMaW5lEkIKCnN0YXJ0UG9pbnQYASABKAsyLi5BaXJTcGFjZUJvdW5kYXJ5VmVydGV4LkFpclNwYWNlQm91bmRhcnlWZXJ0ZXgSQAoIZW5kUG9pbnQYAiABKAsyLi5BaXJTcGFjZUJvdW5kYXJ5VmVydGV4LkFpclNwYWNlQm91bmRhcnlWZXJ0ZXgSMwoOc2VxdWVuY2VudW1iZXIYAyABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRIoCgJpZBgEIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZUJQCi1jb20uZ212LmRlbWV0ZXIubmF2YWlkcy5tb2RlbC5wcm90by5nZW5lcmF0ZWRCH0FpclNwYWNlQm91bmRhcnlWZXJ0ZXhMaW5lUHJvdG9iBnByb3RvMw", [file_AirSpaceBoundaryVertex, file_google_protobuf_wrappers]);

/**
 * @generated from message AirSpaceBoundaryVertexLine.AirSpaceBoundaryVertexLine
 */
export type AirSpaceBoundaryVertexLine = Message<"AirSpaceBoundaryVertexLine.AirSpaceBoundaryVertexLine"> & {
  /**
   * @generated from field: AirSpaceBoundaryVertex.AirSpaceBoundaryVertex startPoint = 1;
   */
  startPoint?: AirSpaceBoundaryVertex;

  /**
   * @generated from field: AirSpaceBoundaryVertex.AirSpaceBoundaryVertex endPoint = 2;
   */
  endPoint?: AirSpaceBoundaryVertex;

  /**
   * @generated from field: google.protobuf.Int32Value sequencenumber = 3;
   */
  sequencenumber?: number;

  /**
   * @generated from field: google.protobuf.StringValue id = 4;
   */
  id?: string;
};

/**
 * Describes the message AirSpaceBoundaryVertexLine.AirSpaceBoundaryVertexLine.
 * Use `create(AirSpaceBoundaryVertexLineSchema)` to create a new message.
 */
export const AirSpaceBoundaryVertexLineSchema: GenMessage<AirSpaceBoundaryVertexLine> = /*@__PURE__*/
  messageDesc(file_AirSpaceBoundaryVertexLine, 0);

